import { render, staticRenderFns } from "./NsMiniCart.vue?vue&type=template&id=b32da302&scoped=true&"
import script from "./NsMiniCart.vue?vue&type=script&lang=js&"
export * from "./NsMiniCart.vue?vue&type=script&lang=js&"
import style0 from "./NsMiniCart.vue?vue&type=style&index=0&id=b32da302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32da302",
  null
  
)

export default component.exports